// extracted by mini-css-extract-plugin
export var statistics = "statistics-list-module--statistics--U5-vS";